import GlobalSettings from "@/services/resources/GlobalSettings"

const actions = {
    async checkCaptchaEnabled({ commit, rootGetters }) {
      try {
        const serviceGlobalSettings = GlobalSettings.build()        
        const response = await serviceGlobalSettings.search({
          keys: 'CAPTCHA_ENABLED' 
        })

        let captchaEnabled = true;
        for (const item of response) {
          if (item.key === 'CAPTCHA_ENABLED') {
            captchaEnabled = item.value.trim() === '0' ? false : true;
            captchaEnabled = process.env.VUE_ADM_PAGE.replace(/^https?:\/\//, '').replace(/\/$/, '') === 'adm.voompcreators.com.br' ? true : captchaEnabled;

            commit('setCaptchaEnabled', captchaEnabled)
            return captchaEnabled
          } else {
            commit('setCaptchaEnabled', captchaEnabled)
            return captchaEnabled
          }
        }
        console.log('captchaEnabled', captchaEnabled, process.env.VUE_ADM_PAGE.replace(/^https?:\/\//, '').replace(/\/$/, ''));
        
      } catch (error) {
        console.error('Error checking beta seller:', error)
        commit('setCaptchaEnabled', true)
        return true
      }
    }
}

export default actions
